// product grid/list
function listgridJavascript() {
  Array.from(document.querySelectorAll(".wblistgridbtn")).forEach((link) => {
    link.addEventListener("click", function (event) {
      Array.from(document.querySelectorAll(".wblistgridbtn")).forEach((e) =>
        e.classList.remove("active")
      );
      this.classList.add("active");
      if (this.classList.contains("listv")) {
        const allEl = document.getElementsByClassName("product-title-ellipses");
        console.log("allEl : ", allEl);
        for (let i = 0; i < allEl.length; i++) {
          allEl[i].classList.remove("full-unstyled-link");
          allEl[i].classList.add("ellipses-list-view");
        }
        document.getElementById("product-grid").classList.add("product-list");
        document
          .getElementById("product-grid")
          .classList.remove("product-grid");
      } else if (this.classList.contains("gridv")) {
        const allEl = document.getElementsByClassName("product-title-ellipses");

        for (let i = 0; i < allEl.length; i++) {
          allEl[i].classList.add("full-unstyled-link");
          allEl[i].classList.remove("ellipses-list-view");
        }

        document.getElementById("product-grid").classList.add("product-grid");
        document
          .getElementById("product-grid")
          .classList.remove("product-list");
      }
    });
  });
}
document.addEventListener("shopify:section:load", listgridJavascript);
listgridJavascript();

// on scroll play video

window.addEventListener("load", videoScroll);
window.addEventListener("scroll", videoScroll);
function videoScroll() {
  if (document.querySelectorAll("video[autoplay]").length > 0) {
    var windowHeight = window.innerHeight,
      videoEl = document.querySelectorAll("video[autoplay]");
    for (var i = 0; i < videoEl.length; i++) {
      var thisVideoEl = videoEl[i],
        videoHeight = thisVideoEl.clientHeight,
        videoClientRect = thisVideoEl.getBoundingClientRect().top;
      if (
        videoClientRect <= windowHeight - videoHeight * 0.5 &&
        videoClientRect >= 0 - videoHeight * 0.5
      ) {
        thisVideoEl.play();
      } else {
        thisVideoEl.pause();
      }
    }
  }
}
